import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiClock } from 'react-icons/fi';
import { supabase } from '../../supabase';
import { useWorkspace } from '../../context/WorkspaceContext';

const TrialBanner = () => {
  const { subscription, isTrialExpired } = useWorkspace();
  const [daysLeft, setDaysLeft] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
            // Check for super_admin role
            const { data: roleData } = await supabase
              .from('user_roles')
              .select('role')
              .eq('user_id', user.id)
              .eq('role', 'super_admin')
              .maybeSingle();

            if (roleData) {
              // User is a super admin, don't show the banner
              setLoading(false);
              return;
            }

            let diffDays = 0;
            if (user.created_at) {
                const created = new Date(user.created_at);
                const now = new Date();
                const diffTime = Math.abs(now - created);
                diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            }
            // Assuming 7 day trial based on memory
            const totalTrialDays = 7;
            const left = totalTrialDays - diffDays;
            setDaysLeft(left > 0 ? left : 0);
        }
      } catch (e) {
        console.error('Error checking trial status', e);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

      if (loading || daysLeft === null || daysLeft > 7 || subscription?.status === 'active' || subscription?.status === 'trialing') return null; // Only show if valid trial period or not subscribed

  // Use gradient background
  return (
    <>
    <div
      className="animate-rainbow-bg text-white px-4 py-2 flex flex-col md:flex-row items-center justify-between shadow-md relative z-40"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center space-x-2 mb-2 md:mb-0">
         <SafeIcon icon={FiClock} className="text-white/90 animate-pulse" />
         <span className="font-medium text-sm">
            Trial: {daysLeft} days remaining. You can generate up to 2 complete client strategies.
         </span>
         <span className="hidden md:inline text-white/80 text-sm mx-2">|</span>
         <span className="hidden md:inline text-sm text-white/90">Upgrade to unlock unlimited strategies & workspaces.</span>
      </div>

      <div className="flex items-center space-x-3">
          <Link
            to="/billing?upgrade=true"
            className="px-4 py-1 bg-white text-blue-600 rounded-full text-xs font-bold hover:bg-blue-50 transition-colors shadow-sm uppercase tracking-wide"
          >
            Upgrade Now
          </Link>
      </div>
    </div>
    </>
  );
};

export default TrialBanner;
